import { Button, Checkbox, FormControlLabel, FormGroup, FormHelperText, Stack } from '@mui/material';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface CheckboxArrayProps {
  name: string;
  options: { value: any; label: any, disabled?: boolean }[];
  selectAll?: boolean;
  selectNone?: boolean;
  row?: boolean;
  disabled?: boolean;
}

function CheckboxArray(props: CheckboxArrayProps) {
  const { name, options, selectAll = false, selectNone = false, row = false, disabled = false } = props;
  const { control, getValues } = useFormContext();
  const {
    field: { onChange },
    fieldState: { error },
  } = useController({ control, name });

  // Must use getValues for the latest value since we are using controlled components
  // Eg. Exchange Targeting
  // We call setValue from AdGroupGeneralSection but field.value will not hold the latest value.
  // Calling getValues or watch gets the latest value; watch() causes too many re-renders in the tests.
  // getValues seems to work better.
  const value = getValues(name);

  return (
    <Stack>
      <FormGroup row={row}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            disabled={option.disabled || disabled}
            control={
              <Checkbox
                value={option.value}
                onChange={(e) => {
                  if (e.target.checked) {
                    if (value) {
                      onChange([...value, option.value]);
                    } else {
                      onChange([option.value]);
                    }
                  } else {
                    onChange(value.filter((v) => v !== option.value));
                  }
                }}
                checked={value && value.includes(option.value)}
              />
            }
            label={option.label}
          />
        ))}
      </FormGroup>
      <Stack direction="row" spacing={1}>
        {(selectAll || options.length > 5) && (
          <Button
            variant="text"
            onClick={() => onChange(options.map((option) => option.value))}
            disabled={!value || value && options.length === value.length}
          >
            Select All
          </Button>
        )}
        {(selectNone || options.length > 5) && (
          <Button variant="text" onClick={() => onChange([])} disabled={value && options.length !== value.length}>
            Deselect All
          </Button>
        )}
      </Stack>
      {error?.message && <FormHelperText error={!!error}>{error?.message ? error?.message : ` `}</FormHelperText>}
    </Stack>
  );
}

export default CheckboxArray;
